module.exports = __webpack_public_path__ + "img/afriqueconsciente_logo.502b92f3.png";